import { graphql } from "../../../graphql"

export const userUpdateMutation = graphql(`
  mutation UserUpdate($input: UserUpdateInput!) {
    userUpdate(input: $input) {
      clientMutationId
    }
  }
`)
